"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationDecoder = exports.ReusableInvitationDecoder = exports.OneOffInvitationDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var timestamp_1 = __importDefault(require("./timestamp"));
var STATUS = 'Invitation.Status';
exports.OneOffInvitationDecoder = ts_data_json_1.JsonDecoder.object({
    email: ts_data_json_1.JsonDecoder.string,
    token: ts_data_json_1.JsonDecoder.string,
    message: ts_data_json_1.JsonDecoder.string,
    status: ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('sent'), ts_data_json_1.JsonDecoder.isExactly('registered')], STATUS),
    expiredAt: timestamp_1.default,
    inviterId: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    teamId: ts_data_json_1.JsonDecoder.string,
}, 'OneOffInvitation');
exports.ReusableInvitationDecoder = ts_data_json_1.JsonDecoder.object({
    token: ts_data_json_1.JsonDecoder.string,
    status: ts_data_json_1.JsonDecoder.isExactly('reusable'),
    expiredAt: timestamp_1.default,
    inviterId: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    teamId: ts_data_json_1.JsonDecoder.string,
}, 'ReusableInvitation');
exports.InvitationDecoder = ts_data_json_1.JsonDecoder.oneOf([exports.OneOffInvitationDecoder, exports.ReusableInvitationDecoder], 'Invitation');
